<template>
  <el-container>
    <el-header>
      <common-header/>
    </el-header>
    <div class="banner banner1">
      <div class="maincontainer">
        <div class="iconapply"></div>
        <div class="title">{{ $t('lang.submit.wantToApply') }}</div>
        <div class="step">
          <div class="step-title">{{ $t('lang.submit.submitApply') }}</div>
          <div class="step-no">
            STEP<span>{{ stepNo }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-main>
      <div class="maincontainer" style="padding: 20px 0">
        <el-form ref="form" size="mini" :model="applyVo" label-width="120px" :disabled="disabled" v-if="applyVo">
          <el-row>
            <el-col :span="16" :offset="4">
              <el-form-item :label-width="isZh ? '150px' : '240px'">
                <div slot="label" class="normal-title">{{ $t('lang.submit.applyNo') }}</div>
                <div class="no">
                  {{ applyVo.applyNo }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4">
              <el-form-item :label-width="isZh ? '150px' : '240px'">
                <div slot="label" class="normal-title">{{ $t('lang.submit.sumAmount') }}</div>
                <el-radio-group v-model="applyVo.chargeCurrency" @change="changeChargeCurrency">
                  <el-radio label="RMB">{{ $t('lang.submit.cnyRmb') }}</el-radio>
                  <el-radio label="DOLLAR">{{ $t('lang.submit.usdDollar') }}</el-radio>
                </el-radio-group>
                <span class="total">{{ applyVo.chargeAmount | moneyFormat }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4">
              <el-form-item :label-width="isZh ? '150px' : '240px'">
                <div slot="label" class="normal-title">{{ $t('lang.submit.chargeDetail') }}</div>
                <div
                  class="item"
                  v-for="(item, index) in applyVo.billDetailVoList"
                  :key="index"
                >
                  <div class="item-name">{{ isZh ? item.chargeItemChinese : item.chargeItemEnglish }}</div>
                  <div class="item-price">{{ item.chargeAmount | moneyFormat }}</div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" v-if="applyVo.chargeAmount > 0">
              <el-form-item :label-width="isZh ? '150px' : '240px'">
                <div slot="label" class="normal-title">{{ $t('lang.submit.payType') }}</div>
                <el-radio-group v-model="applyVo.payType">
                  <el-radio label="ONLINE">{{ $t('lang.submit.onlinePay') }}</el-radio>
                  <el-radio label="CASH" v-if="allowCashPay">{{ $t('lang.submit.cash') }}</el-radio>
                  <el-radio label="BANK_TRANSFER">{{ $t('lang.submit.bankTransfer') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" v-if="applyVo.payType === 'BANK_TRANSFER'">
              <!--              <div class="bankinfo">-->
              <el-form-item :label-width="isZh ? '150px' : '240px'">
                <div slot="label" class="normal-title">{{ $t('lang.submit.ceibsBankAccount') }}</div>
                <div class="bankinfo accountcontent">
                  {{
                    $t('lang.submit.bankName') + (isZh ? bankTransferConfig.chinese.name : bankTransferConfig.english.name)
                  }}<br/>
                  {{
                    $t('lang.submit.bankAddress') + (isZh ? bankTransferConfig.chinese.address : bankTransferConfig.english.address)
                  }}<br/>
                  {{
                    $t('lang.submit.bankAccountName') + (isZh ? bankTransferConfig.chinese.accountName : bankTransferConfig.english.accountName)
                  }}<br/>
                  {{
                    $t('lang.submit.bankAccountNo') + (isZh ? bankTransferConfig.chinese.accountNo : bankTransferConfig.english.accountNo)
                  }}<br/>
                  {{
                    $t('lang.submit.bankTransferPurpose') + (isZh ? bankTransferConfig.chinese.transferPurpose : bankTransferConfig.english.transferPurpose)
                  }}
                </div>
              </el-form-item>
              <!--              </div>-->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4">
              <el-form-item :label-width="isZh ? '150px' : '240px'">
                <div slot="label" class="needtax">
                  <el-checkbox v-model="needReceiptBool" :disabled="disabled">
                    {{ $t('lang.submit.needReceipt') }}
                  </el-checkbox>
                </div>
                <el-input
                  :disabled="disabled || !needReceiptBool"
                  v-model="applyVo.receiptTitle"
                  :placeholder="$t('lang.submit.pleaseInputReceiptTitle')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div class="maincontainer">
        <el-button
          size="mini"
          style="width: 250px"
          type="ceibs"
          @click="goBack"
        >{{ $t('lang.common.goBack') }}
        </el-button
        >
        <el-button
          size="mini"
          style="width: 250px"
          type="ceibsprimary"
          @click="doSubmit"
          :disabled="disabled"
        >{{ $t('lang.submit.doSubmit') }}
        </el-button
        >
      </div>
    </el-main>
    <el-dialog
      custom-class="ceibsdialog"
      :visible.sync="dialogVisible"
      :show-close="false"
      :center="true"
      :width="dialogWidth"
      :close-on-click-modal="false">
      <div class="dialog-content" v-if="applyVo.payType === 'ONLINE'">
        <template v-if="applyVo.payStatus === 'TO_BE_CONFIRMED'">
          <i class="icon iconfont icon-wenhao"></i>
          <div>{{ $t('lang.submit.onlinePaySuccessOrNot') }}</div>
        </template>
        <template v-else>
          <i class="icon iconfont icon-duigou"></i>
          <div>{{ $t('lang.submit.submitSuccess') }}</div>
        </template>
      </div>
      <div class="dialog-content" v-else>
        <i class="icon iconfont icon-duigou"></i>
        <div>{{ $t('lang.submit.submitSuccess') }}</div>
      </div>

      <div slot="footer" class="dialog-footer" v-if="applyVo.payType === 'BANK_TRANSFER'">
        <el-button type="ceibsprimary" @click="uploadTicket">{{
            $t('lang.submit.uploadBankTransferVoucher')
          }}
        </el-button>
        <el-button type="ceibsprimary" @click="checkApplyRecord">{{ $t('lang.submit.checkApplyRecord') }}</el-button>
        <el-button type="ceibsprimary" @click="reApply">{{ $t('lang.submit.applyAgain') }}</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else-if="applyVo.payType === 'ONLINE'">
        <template v-if="applyVo.payStatus === 'TO_BE_CONFIRMED'">
          <el-button type="ceibs" @click="startOnlinePay">
            {{ $t('lang.submit.onlinePayUnFinished') }}
          </el-button>
          <el-button type="ceibsprimary" @click="reloadPage">{{ $t('lang.submit.onlinePayFinished') }}</el-button>
          <div style="margin-top: 10px;">
            <el-button type="ceibsprimary" @click="checkApplyRecord">{{
                $t('lang.submit.checkApplyRecord')
              }}
            </el-button>
          </div>
        </template>
        <template v-else>
          <el-button type="ceibsprimary" @click="checkApplyRecord">{{ $t('lang.submit.checkApplyRecord') }}</el-button>
          <el-button type="ceibsprimary" @click="reApply">{{ $t('lang.submit.applyAgain') }}</el-button>
        </template>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button type="ceibsprimary" @click="checkApplyRecord">{{ $t('lang.submit.checkApplyRecord') }}</el-button>
        <el-button type="ceibsprimary" @click="reApply">{{ $t('lang.submit.applyAgain') }}</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import CommonHeader from '@/components/common/commonHeader'
import { confirmPayTypeAndSubmit, find, generateBillDetail, initOnlinePaySubmit } from '@/api/apply'
import { mapGetters } from 'vuex'
import languageType from '@/locales/languageType'
import { getBankTransferConfig } from '@/api/base'
import { getAccessToken, getRefreshToken } from '@/util/util.ruquest'

export default {
  name: 'submit',
  components: { CommonHeader },
  data () {
    return {
      dialogWidth: '500px', // 对话框宽度
      stepNo: 2, // 当前step，根据申请类型赋值
      dialogVisible: false,
      applyVo: {},
      needReceiptBool: false,
      bankTransferConfig: {
        chinese: {},
        english: {}
      },
      disabled: false,
      payPlatformDto: {}
    }
  },
  inject: ['reload'],
  computed: {
    ...mapGetters([
      'currentLanguage',
      'currentApplyId'
    ]),
    isZh: function () {
      return this.currentLanguage === languageType.zh.code
    },
    isLogin: function () {
      return getAccessToken() && getRefreshToken()
    },
    allowCashPay: function () {
      if (this.applyVo.applyType === 'PAPER') {
        return this.applyVo.packVoList.filter(pack => pack.receiveType === 'ON_SITE' || pack.receiveType === 'ENTRUST_ON_SITE').length > 0
      } else {
        return false
      }
    }
  },
  mounted () {
    this.loadApply()
    this.loadBankTransferConfig()
  },
  methods: {
    goto (url) {
      this.$router.push(url)
    },
    hidedialog () {
      this.dialogVisible = false
    },
    // 上传转帐凭证
    uploadTicket () {
      this.$router.push({
        name: 'applyList',
        params: {
          uploadVoucherApplyId: this.applyVo.id
        }
      })
    },
    // 查看申请记录
    checkApplyRecord () {
      if (!this.isLogin) {
        this.$store.dispatch('setQuickQueryApplyId', this.applyVo.id)
      }
      this.$router.push('applyList')
    },
    // 重新申请，跳转至确认个人信息页面
    reApply () {
      this.$store.dispatch('removeCurrentApplyId')
      this.goto('confirmInfo')
    },
    loadApply () {
      find({
        id: this.currentApplyId
      }).then(res => {
        this.applyVo = res.data
        this.changeStepNo()
        if (this.applyVo.applyStatus === 'CANCELLED') {
          this.$message.info(this.$t('lang.toast.applyAlreadyCancelled'))
          this.$store.dispatch('removeCurrentApplyId')
          this.$router.push('confirmInfo')
        } else if (this.applyVo.applyStatus !== 'DRAFT') {
          this.disabled = true
          this.dialogVisible = true
        } else {
          this.generateBillDetails(this.applyVo)
        }
      })
    },
    changeStepNo () {
      this.stepNo = this.applyVo.applyType === 'PAPER' ? 4 : 2
    },
    loadBankTransferConfig () {
      getBankTransferConfig().then(res => {
        this.bankTransferConfig = res.data
      })
    },
    doSubmit () {
      if (this.applyVo.chargeAmount > 0 && !this.applyVo.payType) {
        this.$message.error(this.$t('lang.submit.validate.pleaseChoosePayType'))
        return
      }
      if (this.applyVo.chargeAmount > 0 && this.needReceiptBool && !this.applyVo.receiptTitle) {
        this.$message.error(this.$t('lang.submit.validate.pleaseInputReceiptTitle'))
        return
      }
      this.applyVo.needReceipt = this.needReceiptBool ? 'Y' : 'N'
      confirmPayTypeAndSubmit(this.applyVo).then(res => {
        this.applyVo = res.data
        this.disabled = true
        this.dialogVisible = true
        if (this.applyVo.payType === 'ONLINE' && this.applyVo.payStatus === 'TO_BE_CONFIRMED') {
          this.startOnlinePay()
        }
      })
    },
    startOnlinePay () {
      initOnlinePaySubmit({
        id: this.applyVo.id,
        lockVersion: this.applyVo.lockVersion
      }).then(res => {
        window.location.href = res.data.payRedirectUrl
      })
    },
    generateBillDetails (applyVo) {
      generateBillDetail({
        ...applyVo
      }).then(billRes => {
        this.applyVo = billRes.data
        this.needReceiptBool = this.applyVo.needReceipt === 'Y'
      })
    },
    changeChargeCurrency () {
      this.generateBillDetails(this.applyVo)
    },
    goBack () {
      if (!this.applyVo) {
        this.goto('login')
      } else if (this.applyVo.applyType === 'PAPER') {
        this.goto('confirmReceiveInfo')
      } else if (this.applyVo.applyType === 'ELECTRONIC') {
        this.goto('confirmPack')
      }
    },
    reloadPage () {
      this.reload()
    }
  }
}
</script>

<style scoped>
.larger-title {
  font-size: 26px;
  font-weight: bold;
}

.normal-title {
  font-size: 18px;
  font-weight: bold;
}

.pay-type-title {
  margin-left: -80px;
}

.needtax {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}

/deep/ .needtax .el-checkbox__label {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}

.total {
  font-size: 36px;
  color: #a2100e;
  font-family: Arial, Helvetica, sans-serif;
  margin-left: 20px;
  font-weight: bold;
  float: right;
}

/deep/ .el-form-item__content {
  text-align: left;
}

.item {
  display: flex;
  padding: 0px 20px;
  align-items: center;
  justify-content: space-between;
  background-color: #ededed;
  margin-bottom: 10px;
  color: #707070;
}

.item:last-child {
  margin-bottom: 0;
}

.item-price {
  color: #a2100e;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 18px;
}

.no {
  color: #a2100e;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 26px;
  font-weight: bold;
}

.bankinfo {
  background-color: #ededed;
  padding: 5px 20px;
  color: #707070;
  margin-bottom: 22px;
}

.bankinfo .el-form-item {
  margin-bottom: 0;
}

.accountcontent {
  line-height: 35px;
}

.noinfo {
  padding: 0 0 5px 15px;
}

/deep/ .el-checkbox__inner {
  width: unset;
  height: unset;
}

</style>
